import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { WHATSAPP_LIVE_CHAT, WHATSAPP_CLAIMS_LIVE_CHAT } from '../../../../routes/routes';
import { INeedHelp } from '../../../../interfaces/NeedHelp/INeedHelp';
import { SA_COUNTRY_ID } from '../../../../constants/internationalization';

class NeedHelp extends React.Component<INeedHelp, any> {

    constructor(props) {
        super(props);
        this.state = {};
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
    }

    handleCallMeBack() {
            this.props.handleCallMeBack();
    }

    public render() {
        let selfInpect = <>
            <div className="needhelp-box-container">
                <div className="row align-items-center">
                    <div className="col">
                        <h3 className="mb-13px mt3px">Need help</h3>
                        <p>We’ll call you back ASAP</p>
                        <button className="btn btn-outline-red fnol-call-me-back-button mb-5px" onClick={this.handleCallMeBack}>Call me back</button>
                    </div>
                    {this.props.countryId === Number(SA_COUNTRY_ID) &&
                        <>
                            <div className="col needhelp-box-col-right">
                                <div className="start-chat cursor-pointer whatsapp-gray" onClick={() => window.open(this.props.isClaims ? WHATSAPP_CLAIMS_LIVE_CHAT : WHATSAPP_LIVE_CHAT, "_blank")}>
                                    <div className="row align-items-center">
                                        <div className="whatsappicon-col">
                                            <Image src="./images/whats-app-icon-68x68-w-shadow.png" alt="Contact Us on WhatsApp" title="Contact Us on WhatsApp" />
                                        </div>
                                        <div className="col whatsapp-text-col align-self-center">
                                            <div className="whatsapp-text-container">
                                                <a className="chat-to-us-via-whats" >Chat to us via WhatsApp</a>
                                                <p className="get-in-touch-with-ou">Get in touch with our friendly support team via WhatsApp. Click here to start chatting</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-none">
                                <button className="btn btn-solid-green claims-whatsapp-mobile mr-2 mb-2" onClick={() => window.open(this.props.isClaims ? WHATSAPP_CLAIMS_LIVE_CHAT : WHATSAPP_LIVE_CHAT, "_blank")}><Image src="./images/whats-app-icon-mobile-24-px.svg" className="img-fluid" /> Chat now via WhatsApp</button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>

        let fnolNeedHelpBlock = <>
            <div id="NeedHelp" className="fnol-needhelp-box">
                <div className="row">
                    <div className="col-12">
                        <h3>Need help</h3>
                        <p>We’ll call you back ASAP</p>
                        <button className="btn btn-outline-red fnol-call-me-back-button" onClick={this.handleCallMeBack}>Call me back</button>
                    </div>
                </div>
            </div>
        </>

        let claimsNeedHelp = <>
            <div className="submit-a-claim-history-block">
                <div className="container py-3">
                    <h3 className="claim-title submit pt-2 mb-2">Need help?</h3>
                    <p className="Speak">Speak to 1 of our claims consultants</p>
                    <p className="contact">Email <a href={"mailto:" + this.props.claimsEmail} target="_blank" style={{ textDecoration: "underline" }} className="normalFont">{this.props.claimsEmail}</a></p>
                    <p className="contact">Phone no. <a href={"tel:" + this.props.contactUsTel} target="_blank" className="normalFont">{this.props.contactUsTel}</a></p>
                    {this.props.countryId === Number(SA_COUNTRY_ID) &&
                        <>
                            <div className="Chat-rectangle d-lg-none d-xl-block d-md-block d-sm-block">
                                <div className="container pt-3">
                                    <div className="row">
                                        <div className="col-3 text-center">
                                            <Image src="./images/whats-app-icon-24-px.svg" />
                                        </div>
                                        <div className="col-9 mt-3">
                                        <a className="chat-to-us-via-whats" href={WHATSAPP_CLAIMS_LIVE_CHAT} target="_blank">Chat to us via WhatsApp</a>
                                            <p className="get-in-touch-with-ou">Get in touch with our friendly support team via WhatsApp. Click here to start chatting</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="Chat-rectangle d-lg-block d-xl-none d-md-none d-sm-none d-xs-none d-none">
                                <div className="container pt-3">
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <Image src="./images/whats-app-icon-24-px.svg" />
                                        </div>
                                        <div className="col-12 ml-3 mr-3 mt-3">
                                        <a className="chat-to-us-via-whats" onClick={() => window.open(WHATSAPP_CLAIMS_LIVE_CHAT, "_blank")}>Chat to us via WhatsApp</a>
                                            <p className="get-in-touch-with-ou">Get in touch with our friendly support team via WhatsApp. Click here to start chatting</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>

        let monthlyMileageDashboard = <>
            <div className="NeedHelp">
                <div className="row col-12">
                    <div className="col-lg-6 mt-3">
                        <h3 className="need-help mb-2">Need help</h3>
                        <p className="contact mb-1">Email&nbsp;<a href={this.props.countryId === Number(SA_COUNTRY_ID) ? "mailto:clientcare@kingprice.co.za" : "mailto:clientcare@kingprice.co.na"} target="_blank"><b>{this.props.countryId === Number(SA_COUNTRY_ID) ? "clientcare@kingprice.co.za" : "clientcare@kingprice.co.na"}</b></a></p>
                        <p className="contact">Phone no.&nbsp;<a href={this.props.countryId === Number(SA_COUNTRY_ID) ? "tel:0860505050" : "tel:0836007000"} target="_blank"><b>{this.props.countryId === Number(SA_COUNTRY_ID) ? "0860505050" : "0836007000"}</b></a></p>
                    </div>
                    {this.props.countryId === Number(SA_COUNTRY_ID) &&
                        <>
                            <div className="col-lg-6">
                                <div className="start-chat d-none d-lg-block cursor-pointer" onClick={() => window.open(WHATSAPP_LIVE_CHAT, "_blank")}>
                                    <div className="row">
                                        <div className="col-3 text-center">
                                            <Image src="./images/whats-app-icon-24-px.svg" />
                                        </div>
                                        <div className="col-md-9 mt-3">
                                        <a className="chat-to-us-via-whats" href={WHATSAPP_LIVE_CHAT} target="_blank">Chat to us via WhatsApp</a>
                                            <p className="get-in-touch-with-ou">Get in touch with our friendly support team via WhatsApp. Click here to start chatting</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-lg-none">
                                <button className="btn btn-solid-green claims-whatsapp-mobile mr-2 mb-2" onClick={() => window.open(WHATSAPP_LIVE_CHAT, "_blank")}><Image src="./images/whats-app-icon-mobile-24-px.svg" className="img-fluid" /> Chat now via WhatsApp</button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>

        let contactUsWhatsAppBlock = <>
            <div className="ssp-contact-us-whatsapp-container cursor-pointer" onClick={() => window.open(this.props.isClaims ? WHATSAPP_CLAIMS_LIVE_CHAT : WHATSAPP_LIVE_CHAT, "_blank")}>
                <div className="row">
                    <div className="col ssp-contact-us-whatsapp-icon-col  ssp-contact-us-whatsapp-icon-col-fnol"></div>
                    <div className="col nopa ssp-contact-us-whatsapp-text-col">
                        <p className="chat-to-us-via-whatsapp">Chat to us via WhatsApp</p>
                        <p className="get-in-touch-with-us-text">
                            Get in touch with our friendly support team via WhatsApp.&nbsp;
                            <span className="desktoponly">Click here</span>
                            <span className="ismobile">Tap here</span>
                            &nbsp;to start chatting.
                        </p>
                    </div>
                </div>
            </div>
        </>
            
        return (
            <>

                {this.props.isContactUsWhatsAppBlock &&
                    contactUsWhatsAppBlock
                }
               
                {this.props.isSelfInspect &&
                    selfInpect
                }

                {this.props.isFnol &&
                    fnolNeedHelpBlock
                }

                {this.props.isClaims && !this.props.isContactUsWhatsAppBlock && 
                    claimsNeedHelp
                }

                {this.props.isMonthlyMileageDashboard &&
                    monthlyMileageDashboard
                }
            </>
        )
    }
}


export default connect()(NeedHelp);